import { IdType } from '../../types/card'
import Button from '../../UI/button'
import ModalCustom from '../../UI/modal'

type Props = {
	show: boolean
	handleClose: () => void
	id?: IdType | null
}

const CloneTripModal = ({show, handleClose, id}: Props) => {
	const handleClone = () => {
		console.log(id);
	} 
	return (
		<ModalCustom show={show} onHide={handleClose} title='Clone The Trip'>
			<div className='d-flex justify-content-between align-items-center'>
				<Button width={180} size='md' variant='dark' onClick={handleClose}>
					Cancel
				</Button>
				<Button width={180} size='md' variant='primary' onClick={handleClone}>
					Clone
				</Button>
			</div>
		</ModalCustom>
	)
}
export default CloneTripModal